import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { switchMap } from 'rxjs';
import { StatesMasterList } from '../models/geo.model';
import { ClfList, MemberList, ShgList, ShgListWithBookkeeper, VoList } from '../models/lokos.model';
import { SearchRequest, SearchResponse } from '../models/response.model';
import { LinkedVOCLF } from '../models/user.model';

const baseUrl = 'https://apis.lokos.in';

@Injectable({
    providedIn: 'root'
})
export class LokosService {
    http = inject(HttpClient);

    getSHGList(payload: SearchRequest) {
        return this.http.post<SearchResponse<ShgList>>(`${baseUrl}/search/lab/cbo`, payload);
    }

    getMemberList(payload: SearchRequest) {
        return this.http.post<SearchResponse<MemberList>>(`${baseUrl}/search/lab/member`, payload);
    }

    getMemberImage(shgUUID: string, memberUUID: string) {
        const url = `${baseUrl}/vault/${shgUUID}/member/${memberUUID}/profile.jpg`;
        return this.http.get(url, { responseType: 'blob' });
    }

    getShgListWithBookkeeper(stateShortCode: string, blockId: string) {
        return this.http.get<ShgListWithBookkeeper[]>(`${baseUrl}/profiles/${stateShortCode}/shg/${blockId}/all`);
    }

    getVoList(stateShortCode: string, blockId: string) {
        return this.http.get<VoList[]>(`${baseUrl}/profiles/${stateShortCode}/vo/${blockId}/all`);
    }

    getClfList(stateShortCode: string, blockId: string) {
        return this.http.get<ClfList[]>(`${baseUrl}/profiles/${stateShortCode}/clf/${blockId}/all`);
    }

    getLinkedVOCLF(stateId: string, districtId: string, blockId: string, subId: string, cboType: 'CLF' | 'VO') {
        return this.http.get<StatesMasterList[]>('https://cdn.lokos.in/lokos-masterdata/statemaster.json').pipe(
            switchMap((stateMaster) =>
                this.http.get<LinkedVOCLF[]>(
                    'https://api.lokos.in/api/profiles/v3/lokos-profile/federation/unmapped/search',
                    {
                        params: {
                            userId: subId,
                            userIdFlag: 1,
                            stateId,
                            districtId,
                            blockId,
                            cboType: cboType === 'CLF' ? 2 : 1
                        },
                        headers: {
                            'x-tenant-identifier': `dynamic_lokos_${stateMaster.find((state) => state.state_id === +stateId)!.state_short_name_en.toLowerCase()}`
                        }
                    }
                )
            )
        );
    }
}
